// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"6608afd2","453":"c68b8744","627":"f5a5ebb4","905":"68cea474","923":"37881ed6"}[chunkId] + ".chunk.js";
};